import requestOptions from './requestOptions'
import invoiceMapper from '../models/Invoice_Mapper'
import { logError } from '../../logs/ErrorLoger'

const getPendingInvoiceService = async (paremeters, businessId, invoiceId, type, page, perPage, search) => {
  try {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.INVOICES + '/' + businessId + '/' + invoiceId + '/' + type + '/' + page + '/' + perPage + '/' + search, options)
    const data = await resp.json()
    let response;
    if (invoiceId === 0) {
      response = invoiceMapper.invoiceMapper(data.data)
    } else {
      response = invoiceMapper.invoiceByIdMapper(data.data, data.error)
    }
    return response
  } catch (error) {
    await logError(error.message, 'Invoice', 'Invoice.jsx')
    return { error: global.MESSAGE_ERROR_CATCH }
  }
}

const sentInvoiceToEmailService = async (paremeters, businessId, invoiceId) => {
  try {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.INVOICES_TO_EMAIL + '/' + businessId + '/' + invoiceId, options)
    const response = await resp.json()
    return response
  } catch (error) {
    await logError(error.message, 'Invoice', 'Invoice.jsx')
    return { error: global.MESSAGE_ERROR_CATCH }
  }
}

const invoiceServices = {
  getPendingInvoiceService,
  sentInvoiceToEmailService
}

export default invoiceServices
